module.exports = __webpack_public_path__ + "media/images/illustrations/flat_clip_upgrade-a16ab844b8d72aeef96da16982294408.png";